import { useNavigate } from 'react-router-dom';

import { useQuery } from '@tanstack/react-query';

import { getQuotes } from 'api/Quotes';

export const useQuotes = ({ params = {}, options = {}, dependencies = [] }) => {
  const navigate = useNavigate();

  return useQuery(['quotes', ...dependencies], () => getQuotes(navigate, params), {
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...options
  });
};
